export default "__VITE_ASSET__23c2c821__"